<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="标签名称:" prop="labelName">
                <el-input placeholder="" v-model="searchFrom.labelName"></el-input>
              </el-form-item>
            </div>
        </div> 
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="applyClick">新增</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="delFn(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="labelName"  min-width="200" :formatter="emptyFn" label="标签名称"></el-table-column> 
        <el-table-column prop="remark"  min-width="270" :formatter="emptyFn" label="备注信息"></el-table-column>
        <el-table-column prop="createUserName"  min-width="120" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime"  min-width="160" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <el-dialog  title="添加标签"  :visible.sync="SQMark" width="400px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="130px" size="mini">
        <div class="inpBox">
            <div style="margin: 28px 0;">
                <el-form-item label="标签名称:" prop="labelName">
                  <el-input v-model="SQFrom.labelName" placeholder="" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="备注信息:" prop="remark" >
                  <el-input type="textarea" v-model="SQFrom.remark" style="width:150px"></el-input>
                </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false">取消</el-button>
        <el-button type="primary" @click="SQsave()">确定</el-button>
      </span>
   </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { 
         cOcrModelLabelAdd, // 添加确定
         cOcrModelLabelList, // 列表
         cOcrModelLabelDelete // 删除
         } from '@/api/common-signature'
export default {
  data () {
    return {
      SQFrom: {
      },
      SQMark: false,
      rules: {
        labelName: [
          { required: true, message: '请输入标签名称', trigger: 'blur' }
        ],
      },
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
     SQsave () {
        this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
        cOcrModelLabelAdd(this.SQFrom).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cOcrModelLabelDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
     // 申请签章 
    applyClick(){
      this.SQMark = true
      this.$nextTick(() => {
        this.$refs["SQFrom"].clearValidate(); 
      })
      // this.$set(this.SQFrom, 'tenantName', localStorage.getItem('tenantName'))
      // this.$set(this.SQFrom, 'tenantTaxpayerNumber', localStorage.getItem('tenantTaxpayerNumber'))
      // this.$set(this.SQFrom, 'userName', localStorage.getItem('userName'))
      // this.$set(this.SQFrom, 'mobile', localStorage.getItem('mobile'))
    },
    // 查选
    searchFn () {
      // if (this.searchFrom.billNo) { this.searchFrom.billNos = this.searchFrom.billNo.split(/[(\r\n)\r\n]+/) } else {
      //   this.searchFrom.billNos = ''
      // }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      cOcrModelLabelList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.SQFrom = {
      }
    },
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}


.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;  
  }
}
 .xieyiBigBox{
      position: relative;
      top: 10px;
      left: 26%;
    }
    .xieyi{
      color: #409EFF;
      cursor: pointer;
    }
    a{
      text-decoration:none;
    }
    .applySignatureimg {
      margin-left: 80px;
    }

</style>
